/**
 * Shown when the request Host maps to a REAL tenant that is currently SUSPENDED
 * (ADR-0036 Fase 2 — control plane). Distinct from {@link TenantNotFound}: the
 * organisation exists, its data plane is just closed by a platform admin. The
 * backend `TenantMiddleware` 403s the API for this tenant; this is the matching
 * end-user page (the SPA shell still loads so the gate can render it).
 */
import { PauseCircle } from "lucide-react";

export function TenantSuspended({ slug }: { slug?: string | null }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md rounded-xl border border-border/60 bg-surface p-8 text-center shadow-lg">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-warning/15">
          <PauseCircle className="h-6 w-6 text-warning" strokeWidth={1.5} />
        </div>
        <h1 className="text-lg font-semibold text-foreground">Account sospeso</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {slug ? (
            <>
              L'organizzazione <span className="font-mono text-foreground">{slug}</span> è
              temporaneamente sospesa.
            </>
          ) : (
            <>Questa organizzazione è temporaneamente sospesa.</>
          )}
        </p>
        <p className="mt-4 text-xs text-muted-foreground">
          Contatta l'amministratore della piattaforma per riattivare l'accesso.
        </p>
      </div>
    </div>
  );
}
